export const sizes = {
    card: {
        width: 126,
        height: 196,
        ratio: 196 / 126,
    },
};
